import type { WebappResponse } from '@eventbrite/event-listing-service-client';

export const fetchFreshEventContext = async (eventId: string): Promise<WebappResponse | null> => {
  try {
    const response = await fetch(`/e/api/${eventId}/context`, {
      method: 'GET',
      cache: 'no-store',
    });
    if (!response.ok) {
      return null;
    }

    return (await response.json()) as WebappResponse;
  } catch {
    return null;
  }
};
